import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import InfiniteScroll from 'components/GeneralComponents/InfiniteScroll';
import { default as PostStyled } from './styled';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import blocks from '../../blocks';
import elements from '../../elements';
import { UploadChatMessageImage } from '../../../../../helpers/api-calls/feed-calls';
import Confirm from './Confirm';
import Modal from 'components/GeneralComponents/Modal';
import './ChatMessagesComponent.scss';

import { Mixpanel } from 'helpers/Mixpanel';
import { extractChatParticipant } from 'helpers/community-util';
import { getUserId } from '../../../../../helpers/cookies';

const sha1 = require('js-sha1');

class ChatMessagesComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      debug: false,
      userInput: '',
      enterKeyPressed: false,
      currentChannel: -1,
      textAreaHeight: 30,
      checkedAnnouncement: false,
      imageDataUrl: '',
      imageDataUrlList: [],
      imageInfoList: [],
      detectedUrl: '',
      previews: [],
      userInput2: '',
      contentWithUrl: '',
      localPosts: [],
      finalAllowPost: 0,
      deletedPostId: -1,
      showSnackbar: false,
      timer: null,
      actionMenuPos: null,
      iconPos: null,
      showConfirmDelete: false,
      lastAction: '',
      isSending: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleReaderLoaded = this.handleReaderLoaded.bind(this);
    this.handlePreviewChange = this.handlePreviewChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.fileInput = React.createRef();
    this.textInput = React.createRef();
    this.imagePreView = React.createRef();
    this.previewFrame = React.createRef();
    this.previewInput = React.createRef();
    this.buttonMoreRef = React.createRef();
    this.snackbarRef = React.createRef();
    this.warningRef = React.createRef();

    this.imgUrlListIndex = 0;
    this.isChrome = false;
    this.urlDetected = false;
    this.detectedUrl = '';
    this.startTime = 0;
    this.endTime = 0;
    this.activePost = null;
    this._isMounted = false;
    this.allImagesUploaded = false;
    this.postCreated = false;
    this.activeChatSessionId = 0;
    this.mqttClient = props.mqttClient;
    this.mqttTopic = `user_event/${sha1(`user.${getUserId()}`)}`;
    this._messageHandler = null;

  }

  messages = defineMessages({
    pressKeyPrompt: {
      id: 'PostComponent.pressKeysSubmit',
      defaultMessage: "Press CTRL + Enter to submit",
    },
    chooseFile: {
      id: 'PostComponent.chooseFile',
      defaultMessage: "Choose File",
    },
    noFileChosen: {
      id: 'PostComponent.noFileChosen',
      defaultMessage: "No file chosen",
    },
    maxFilesExceeded: {
      id: 'PostComponent.maxFilesExceeded',
      defaultMessage: "Cannot upload more than {maxFiles} files at one time.",
    }
  });

  acceptedTypes = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/webp',
  ];

  isValidFileType(fileType) {
    return this.acceptedTypes.includes(fileType);
  };


  isAnnouncement(post_type) {
    return [1, 2, 3, 4].includes(post_type);
  }

  containUrl(text) {
    if (typeof text !== 'string' || text.length < 5) return false;
  
    const urlRegex = /\b((https?:\/\/)?(www\.)?[\w-]+\.[a-z]{2,}(\/\S*)?)/i;
    return urlRegex.test(text);
  }

  extractUrl(text) {
    const urlRegex = /\b((https?:\/\/)?(www\.)?[\w-]+\.[a-z]{2,}(\/\S*)?)/i;
  
    if (typeof text !== 'string' || text.length < 5) return null;
  
    const match = text.match(urlRegex);
    if (!match || !match[1]) return null;
  
    let url = match[1];
  
    // Remove trailing comma or period from URL
    const lastChar = url.slice(-1);
    if (lastChar === ',' || lastChar === '.') {
      url = url.slice(0, -1);
    }
  
    const start = text.indexOf(url);
    const beforeUrl = start > 0 ? text.substring(0, start) : '';
    const afterUrl = text.substring(start + url.length);
  
    return (
      <span>
        {beforeUrl}
        <a href={url.startsWith('http') ? url : `https://${url}`} onClick={this.handleUrlClick}>
          {url}
        </a>
        {afterUrl}
      </span>
    );
  }

  dropRef = React.createRef();

  componentDidMount() {
    const {
      fetchPosts,
      fetchChatMessages,
      active: { chatSession, channel },
      setActivePost,
      activeChat,
      posts,
      chatMessages,
      allowCreatePost,
      locations,
      locationId,
      allUsers,
      onlineUsers,
    } = this.props;

    this._isMounted = true;
    if (activeChat) {
      this.mqttSubscribe();
    }

    if (!chatMessages.loading && chatSession) {
      setActivePost(0, '');
      fetchChatMessages(chatSession, 1);
    }

    if (!chatMessages.loading) {
      if (chatMessages.data.length > 0 && this.state.localPosts.length === 0) {
        this.setState({ localPosts: chatMessages.data });
      }
    }
    this.isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 ? true : false;

    if (this.state.previews.length > 0 && this.previewInput.current) {
      this.previewInput.current.focus();
    } else if (this.textInput && this.textInput.current) {
      this.textInput.current.focus();
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._messageHandler && this.mqttClient) {
      this.mqttClient.removeListener('message', this._messageHandler);
      this.mqttClient.unsubscribe(this.mqttTopic);
    }
    clearInterval(this.state.timer);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      active: { chatSession, channel },
      posts,
      chatMessages,
      locations,
      locationId,
      onlineUsers,
      activeChat,
      setLastPost,
      updateChannelLastContent,
      allUsers,
      setActiveChatSession,
      fetchChatMessages,
    } = this.props;
    const {
      active: { chatSession: prevChatSession, channel: prevChannel },
    } = prevProps;
    const { localPosts, deletedPostId, lastAction, showSnackbar, } = this.state;

    if (prevChatSession !== chatSession) {
      const hasCachedMessages = chatMessages?.data?.length > 0;

      if (!hasCachedMessages) {
        fetchChatMessages(chatSession, 1);
      }

      // reset unsend post/announcement
      this.setState({ userInput: '', });
      this.setState({ userInput2: '', });
      if (this.fileInput.current) {
        this.fileInput.current.value = '';
      }
      this.setState({ previews: [] });
      this.setState({ imageDataUrl: '' });
      this.setState({ imageDataUrlList: [] });
      this.setState({ imageInfoList: [] });
      this.setState({ checkedAnnouncement: false });
      this.setState({ contentWithUrl: '' });
      this.imgUrlListIndex = 0;

      // Focus input when chat session changes
      if (this.state.previews.length > 0 && this.previewInput.current) {
        this.previewInput.current.focus();
      } else if (this.textInput.current) {
        this.textInput.current.focus();
      }
    }

    // the state 'localPosts' is used to prevent re-render all comments when new comment added
    if (prevProps.chatMessages !== chatMessages) {
      this.setState({ localPosts: chatMessages.data });
      if (chatMessages.data.length > 0) {
        // const lastContent = `${chatMessages.data[chatMessages.data.length - 1].owner.first_name} ${chatMessages.data[chatMessages.data.length - 1].owner.last_name}: ${chatMessages.data[chatMessages.data.length - 1].content ? chatMessages.data[chatMessages.data.length - 1].content : ''}`;
        // const channelId = activeChat ? activeChat.id : 0;
        // const payload = {
        //   channel_id: channelId,
        //   content: lastContent,
        // }
        // updateChannelLastContent(payload);
      } else {
        if (prevProps.chatMessages && prevProps.chatMessages.data.length === 1) {
          const channelId = activeChat ? activeChat.id : 0;
          const payload = {
            channel_id: channelId,
            content: '',
          }
          updateChannelLastContent(payload);
        }
      }

      //show snackbar for deleting a post
      if (prevProps.chatMessages && prevProps.chatMessages.data.length > 0) {
        if (prevProps.chatMessages.data.length - 1 === chatMessages.data.length) {
          if (lastAction === 'delete') {
            this.setState({ showSnackbar: true });
            this.startTimer(10000);
          }
        }
      }
    }

    // NOTE: Presence tracking removed — will be handled separately in a future phase.

    if (prevState.deletedPostId !== deletedPostId) {
      let lastPost = null;
      if (localPosts && localPosts.length > 0) {
        const idx = localPosts.findIndex((post) => post.id === deletedPostId);
        if (idx >= 0) {
          if (idx === 0) {
            if (localPosts.length > 1) {
              lastPost = localPosts[localPosts.length - 1];
            }
          } else if (idx === localPosts.length - 1) {
            if (localPosts.length > 1) {
              lastPost = localPosts[localPosts.length - 2];
            } else {
              lastPost = localPosts[0];
            }
          } else {
            lastPost = localPosts[localPosts.length - 1];
          }
        }
        setLastPost(lastPost);
      }
    }
  }

  mqttSubscribe = () => {
    if (!this.mqttClient) {
      console.warn('[ChatMessagesComponent] MQTT client not available, skipping subscribe');
      return;
    }

    const {
      getLocationOnlineUsers,
      handleAddUserToOnlineList,
      handleRemoveUserFromOnlineList,
      NotifyNewChatMessage,
      fetchOneChatMessage,
    } = this.props;

    this._messageHandler = (topic, payload) => {
      let message;
      try {
        message = JSON.parse(payload.toString());
      } catch (err) {
        console.error('[ChatMessagesComponent] Failed to parse MQTT message:', err);
        return;
      }

      if (
        message.receiver_id == getUserId() &&
        message.event === 'chat_message' &&
        message.crud === 'NEW'
      ) {
        console.log('received new message this.postCreated: ', this.postCreated);
        if (!this.postCreated) {
          if (message.tree_id === this.activeChatSessionId) {
            fetchOneChatMessage(this.activeChatSessionId, message.node_id);
          } else {
            fetchOneChatMessage(message.tree_id, message.node_id);
            NotifyNewChatMessage(message.tree_id);
          }
        }
        this.postCreated = false;
      }
    };

    this.mqttClient.on('message', this._messageHandler);
    this.mqttClient.subscribe(this.mqttTopic);

    // NOTE: Presence/hereNow features are not available via MQTT.
    // Online user presence will be handled separately in a future phase.
  };

  autoExpand = function (field) {
    var height = field.scrollHeight;
    field.style.height = height + 'px';
  };

  resetInputHeight = function (field) {
    if (field) {
      field.style.height = '56px';
    } else if (this.textInput.current) {
      this.textInput.current.style.height = "56px";
    }
  };

  startTimer = (timeOut) => {
    const myTimer = setInterval(this.tick, timeOut); //unit: ms
    if (this._isMounted) {
      this.setState({ timer: myTimer });
    }
  }

  tick = () => {
    if (this._isMounted) {
      this.setState({ showSnackbar: false, lastAction: '' });
      this.setState({ timer: null });
    }
  }

  handleScrollLoad = () => {
    const {
      active: { chatSession },
      fetchMoreChatMessages,
      chatMessages,
    } = this.props;

    const page = chatMessages.page ?? 1;
    const totalPages = chatMessages.totalPages ?? 1;

    if (page < totalPages) {
      fetchMoreChatMessages(chatSession, page + 1);
    }
  };

  handleChange(event) {
    this.setState({ userInput: event.target.value });
    let text = event.target.value;

    if (text !== null && text.length > 0) {
      this.autoExpand(event.target);
    } else {
      this.resetInputHeight(event.target);
    }

    event.preventDefault();
  }

  handlePreviewChange = (event) => {
    const value = event.target.value;
    this.setState({ userInput2: value }, () => {
      if (this.previewInput.current) {
        const el = this.previewInput.current;
        el.style.height = 'auto';
        el.style.height = `${Math.min(el.scrollHeight, 200)}px`; // cap at 200px
      }
    });
  };

  handleImageChange(event) {
    const { intl } = this.props;
    const MAX_NUM_FILES = 10;
    const files = Array.from(event.target.files);

    if (!files.length) return;

    const totalFiles = files.length + this.state.previews.length;
    if (totalFiles > MAX_NUM_FILES) {
      const msg = intl.formatMessage(this.messages.maxFilesExceeded, { maxFiles: MAX_NUM_FILES });
      alert(msg);
      this.fileInput.current.value = '';
      return;
    }

    const newPreviews = [...this.state.previews];

    for (const file of files) {
      const { type, name, size } = file;

      if (!this.isValidFileType(type)) {
        alert('Only images are allowed (png or jpg)');
        this.fileInput.current.value = '';
        return;
      }


      newPreviews.push(URL.createObjectURL(file));

      // Trigger base64 read (used somewhere else?)
      const reader = new FileReader();
      reader.onload = this.handleReaderLoaded;
      reader.readAsDataURL(file);
    }

    // Single batched update to state
    this.setState({
      previews: newPreviews,
    });

    // Reset file input
    this.fileInput.current.value = '';

    // Handle focus logic
    const hasAnyFiles = newPreviews.length > 0;
    if (hasAnyFiles && this.previewInput.current) {
      this.previewInput.current.focus();
    } else if (this.textInput.current) {
      this.textInput.current.focus();
    }

    event.preventDefault();
  }


  handleReaderLoaded(event) {
    const result = event?.target?.result;
    if (!result) return;

    this.setState((prevState) => ({
      imageDataUrl: result,
      imageDataUrlList: [...prevState.imageDataUrlList, result],
    }));

    event.preventDefault();
  }

  handleSubmit(event) {
    this.sendMessage();
    event.preventDefault();
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // block newline
      this.sendMessage();     // send the message
      Mixpanel.track('Posted message');
    }
  };

  sendMessage() {
    const { activeChat, createChatMessage } = this.props;
    const { previews, userInput, userInput2, imageDataUrlList } = this.state;

    const content = userInput2 || userInput;
    this.setState({ isSending: true });
    if (previews.length > 0 && imageDataUrlList.length > 0) {
      this.imgUrlListIndex = 0;
      this.allImagesUploaded = false;
      this.startTime = Date.now();

      UploadChatMessageImage(imageDataUrlList[0])
        .then((data) => data?.image && this.succeededCallback(data))
        .catch(this.failedCallback);
    } else if (content && !this.urlDetected) {
      createChatMessage(activeChat.id, {
        message_type: 'message_default',
        message: content,
      });
      this.postCreated = true;
      this.clearInputState();
      this.setState({ isSending: false });
    }
  }

  succeededCallback(data) {
    const { activeChat, createChatMessage } = this.props;
    if (!data?.image) return;

    const [w, h] = (data.image.avatar_meta?.slice(1, -1).split(',') || []).map(Number);
    const newImageInfo = {
      object_instances: {
        class_name: data.image.class_name,
        id: data.image.id,
        image_name: data.image.image_name,
        image_width: w,
        image_height: h,
      },
    };

    this.setState((prev) => ({
      imageInfoList: [...prev.imageInfoList, newImageInfo],
    }), () => {
      this.imgUrlListIndex += 1;

      if (this.imgUrlListIndex < this.state.imageDataUrlList.length) {
        UploadChatMessageImage(this.state.imageDataUrlList[this.imgUrlListIndex])
          .then((nextData) => nextData?.image && this.succeededCallback(nextData))
          .catch(this.failedCallback);
      } else {
        const totalTime = ((Date.now() - this.startTime) / 1000).toFixed(2);
        console.log(`Uploaded ${this.state.imageDataUrlList.length} images in ${totalTime}s`);

        const imgUrl = data.image.full_url;
        createChatMessage(activeChat.id, {
          message_type: 'message_image',
          message: `[IMG]${imgUrl}[/IMG]`,
        });

        this.postCreated = true;
        this.clearInputState();
        this.setState({ isSending: false });
      }
    });
  }

  failedCallback = (error) => {
    console.error('Upload failed, retrying...', error);
    this.setState({ isSending: false });
    if (this.state.imageDataUrlList.length > 0) {
      UploadChatMessageImage(this.state.imageDataUrlList[this.imgUrlListIndex])
        .then((data) => data?.image && this.succeededCallback(data))
        .catch(this.failedCallback);
    } else {
      alert('Image upload failed.');
    }
  }

  clearInputState() {
    this.setState({
      userInput: '',
      userInput2: '',
      previews: [],
      imageDataUrl: '',
      imageDataUrlList: [],
      imageInfoList: [],
      checkedAnnouncement: false,
      isSending: false,
    });
    this.fileInput.current.value = '';
    this.imgUrlListIndex = 0;
    this.resetInputHeight?.();
  }

  handleDelete = (index, type) => {
    if (type === 'image') {
      const previews = [...this.state.previews];
      previews.splice(index, 1);
      this.setState({ previews });
    }
  };

  getUserUUID = (userId) => {
    return `user.${sha1(`user.${userId}`)}`;
  };

  notifyPostHeightChanged = (value) => {
    window.scrollTo({ bottom: value, left: 0, behavior: "smooth" });
  }

  renderChatMessages = () => {
    const {
      active,
      chatMessages: { data, page },
      setActivePost,
      setActiveDelete,
      setActiveSidePane,
      userIsAdmin,
      activeChat,
      userId,
      allUsers,
      onlineUsers,
    } = this.props;

    const { localPosts, deletedPostId, showConfirmDelete, } = this.state;

    const visiblePosts = localPosts.map((post, index) => (
      <blocks.ChatMessage
        key={index}
        clickDelete={() => {
          setActiveDelete({
            id: post.id,
            type: this.isAnnouncement(post.post_type) ? 'announcement' : 'post',
          });
          this.setState({ deletedPostId: post.id });
          this.setState({ showConfirmDelete: true });
        }}
        clickCopy={() => {
          if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(post.content);
            this.setState({ showSnackbar: true, lastAction: 'copy' });
            Mixpanel.track('Copy post', { 'post_id': post.id });
            this.startTimer(10000);
          } else {
            console.log('The Clipboard API is not available');
          }
        }}
        active={active.post.id === post.id || active.delete.id === post.id}
        data={{
          ...post,
          final_allow_delete: active.userIsAdmin || post.owner_id === userId, // Fixed bug WS-1279, WS-1262
        }}
        allUsers={allUsers}
        onlineUsers={onlineUsers}
        index={index}
        setActiveSidePane={setActiveSidePane}
        setActivePost={setActivePost}
        activeChat={activeChat}
      />
    ));
    const scrollTrackingIndex = data.length / page;

    visiblePosts.splice(
      scrollTrackingIndex,
      0,
      <div key={`bookmark_${new Date().getTime()}`} id="scroll__bookmark" />
    );

    return visiblePosts;
  };

  getFormDataContent = (formData) => {
    const { file } = formData;
    let keys = Object.keys(formData);
    keys = keys.filter(key => key !== "file");
    const data = {
      lastModified: file.lastModified,
      lastModifiedDate: file.lastModifiedDate,
      name: file.name,
      size: file.size,
      type: file.type
    };
    const fileData = { file: data };
    keys.forEach(key => {
      fileData[key] = formData[key];
    });
    return fileData;
  };

  renderSnackbar = (info) => {
    let winTop = '';
    let winLeft = '';
    const winW = '160px';
    const winH = `60px`;

    let domNode = null;
    let output = null;
    if (this.textInput && this.textInput.current) {
      domNode = ReactDOM.findDOMNode(this.textInput.current);
      output = domNode.getBoundingClientRect();
      if (output) {
        winTop = `${output.y + output.height - 36}px`;
        winLeft = `${output.x + 120}px`;
      }
    } else {
      if (this.warningRef && this.warningRef.current) {
        domNode = ReactDOM.findDOMNode(this.warningRef.current);
        output = domNode.getBoundingClientRect();
        if (output) {
          winTop = `${output.y + output.height - 100}px`;
          winLeft = `${output.x + 150}px`;
        }
      }
    }

    if (winTop !== '' && winLeft !== '') {
      return (
        <PostStyled.WinContainer ref={this.snackbarRef} top={winTop} left={winLeft}>
          <div className="status__wrap">
            <label className="status__text">{info}</label>
          </div>
        </PostStyled.WinContainer>
      );
    }
  }

  notifyCancel = () => {
    this.setState({ showConfirmDelete: false });
    Mixpanel.track('Cancel delete post');
  }

  notifyDelete = () => {
    const { deletePost, posts, } = this.props;
    const { deletedPostId, } = this.state;
    this.setState({ showConfirmDelete: false, lastAction: 'delete' });

    if (deletedPostId >= 0) {
      deletePost(deletedPostId, posts.lastPost);
      Mixpanel.track('Deleted post', { 'post_id': deletedPostId });
    }
  }

  renderHeader(sessionUserName, avatarUrl, condition, approvedBadge) {
    const { debug, } = this.state;
    const { activeChat } = this.props;

    return (
      <div className="posts__wrap" style={{ paddingTop: '12px', paddingBottom: '12px', maxHeight: '60px' }}>
        {debug && <p>{activeChat.id}</p>}
        {activeChat && <PostStyled.ChannelAvatar src={avatarUrl} />}
        <div className="posts__info-wrap">
          <div className="posts__top-line">
            <label className="posts__title">{sessionUserName}</label>
            {/* {condition && <PostStyled.ApprovedBadge src={approvedBadge} />} */}
          </div>
        </div>
      </div>
    );
  }

  renderInputControls() {
    const { previews, userInput, userInput2, imageDataUrlList } = this.state;
    const content = userInput2 || userInput;

    return (
      <PostStyled.ButtonsDiv>
        <PostStyled.ChooseFileLabel>
          <PostStyled.ChooseFile
            id="file-choose"
            type="file"
            accept={this.acceptedTypes.join(',')}
            ref={this.fileInput}
            onChange={this.handleImageChange}
          />
        </PostStyled.ChooseFileLabel>


        <PostStyled.SubmitButton disabled={!((previews.length > 0 && imageDataUrlList.length > 0) || (content && !this.urlDetected))} onClick={this.handleSubmit} />
      </PostStyled.ButtonsDiv>
    );
  }

  renderInput(placeholder) {
    return (
      <PostStyled.PostInputForm onSubmit={this.handleSubmit} noAttached={!this.state.previews.length} notChrome={!this.isChrome}>
        <PostStyled.PostInput
          id="drop-area"
          type="textarea"
          value={this.state.userInput}
          placeholder={this.state.isSending ? 'Sending...' : placeholder}
          multiline
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          ref={this.textInput}
          disabled={this.state.isSending}
        />
        {this.renderInputControls()}
      </PostStyled.PostInputForm>
    );
  }

  renderPreviewInput() {
    return (
      <PostStyled.PreviewFrame ref={this.previewFrame}>
        {this.state.isSending && (
          <PostStyled.SendingOverlay>
            <PostStyled.Spinner />
            <span style={{ marginTop: '8px' }}>Uploading image...</span>
          </PostStyled.SendingOverlay>
        )}
        <PostStyled.AttachmentScrollRow>
          {this.state.previews.map((src, index) => (
            <PostStyled.AttachmentWrapper key={index}>
              <PostStyled.AttachmentImage src={src} />
              <PostStyled.AttachmentRemoveButton
                onClick={() => this.handleDelete(index, 'image')}
              >
                ×
              </PostStyled.AttachmentRemoveButton>
            </PostStyled.AttachmentWrapper>
          ))}
        </PostStyled.AttachmentScrollRow>
        {this.renderInputControls()}
      </PostStyled.PreviewFrame>
    );
  }

  render() {
    const {
      active,
      chatMessages,
      activeChat,
      intl,
    } = this.props;

    const {
      showSnackbar,
      showConfirmDelete,
      lastAction,
      previews,
    } = this.state;

    this.activeChatSessionId = activeChat ? activeChat.id : 0;

    const approvedBadge = '/icons/verified-badge-icon.svg';

    const participant = extractChatParticipant(activeChat);
    const sessionUser = participant ? participant.owner : null;
    const sessionUserName = sessionUser ? `${sessionUser.first_name} ${sessionUser.last_name}` : '';

    let avatarUrl = '';
    if (sessionUser && sessionUser.thumb_url) {
      avatarUrl = sessionUser.thumb_url;
    } else {
      avatarUrl = '/icons/default-profile-thumb.svg';
    }


    const msg = intl.formatMessage(this.messages.pressKeyPrompt);
    const placeholder = `Message: ${sessionUserName}`;

    const snackbarText = lastAction === 'copy'
      ? (<FormattedMessage id="PostComponent.textCopied" defaultMessage="Text Copied to Clipboard" />)
      : lastAction === 'delete'
        ? (<FormattedMessage id="PostComponent.messageDeleted" defaultMessage="Message deleted successfully" />)
        : null;

    return (
      <elements.ColumnWrap id="columnWrap">
        {this.renderHeader(sessionUserName, avatarUrl, true, approvedBadge)}

        <elements.ScrollWrap reverse isLoading={chatMessages.loading}>
          <InfiniteScroll
            isLoading={chatMessages.loading}
            onEnter={this.handleScrollLoad}
          />
          {!chatMessages.loading || <elements.Loading />}
          {this.renderChatMessages()}
        </elements.ScrollWrap>

        {previews.length > 0
          ? this.renderPreviewInput()
          : this.renderInput(placeholder)
        }

        {showSnackbar && (
          <Modal>{this.renderSnackbar(snackbarText)}</Modal>
        )}

        {showConfirmDelete && (
          <Modal>
            <Confirm
              title={<FormattedMessage id="PostComponent.confirmDeleteTitle" defaultMessage="Delete Message" />}
              content={<FormattedMessage id="PostComponent.confirmDeleteContent" defaultMessage="Are you sure you want to delete this message? This cannot be undone." />}
              notifyCancel={this.notifyCancel}
              notifyDelete={this.notifyDelete}
            />
          </Modal>
        )}

        <PostStyled.Overlay display={showConfirmDelete ? 'block' : 'none'} />
      </elements.ColumnWrap>
    );
  }
}

ChatMessagesComponent.propTypes = {
  setActivePost: PropTypes.func.isRequired,
  setActiveDelete: PropTypes.func.isRequired,
  setActiveSidePane: PropTypes.func.isRequired,
  mqttClient: PropTypes.object.isRequired,
};

export default injectIntl(ChatMessagesComponent);
